import { render } from "./newIndex.vue?vue&type=template&id=32b5cd53&scoped=true"
import script from "./newIndex.vue?vue&type=script&lang=js"
export * from "./newIndex.vue?vue&type=script&lang=js"

import "./newIndex.vue?vue&type=style&index=0&id=32b5cd53&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b5cd53"]])

export default __exports__